/* MORII theme v2 - minimal JS */
(() => {
  'use strict';

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const open = mobileMenu.toggleAttribute('hidden');
      menuToggle.setAttribute('aria-expanded', String(!open));
    });
  }

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
  }

  const productJson = document.querySelector('[data-product-variants]');
  let productVariants = null;
  if (productJson) {
    try { productVariants = JSON.parse(productJson.textContent); } catch (e) {}
  }
  const moneyFormat = (cents) => '$' + (cents / 100).toFixed(2);
  const resolveVariant = () => {
    if (!productVariants) return;
    const groups = Array.from(document.querySelectorAll('[data-swatches]'));
    if (!groups.length) return;
    groups.sort((a, b) => (parseInt(a.dataset.optionPosition, 10) || 0) - (parseInt(b.dataset.optionPosition, 10) || 0));
    const selected = groups.map((g) => {
      const pressed = g.querySelector('[data-swatch][aria-pressed="true"]');
      return pressed ? pressed.dataset.swatch : null;
    });
    if (selected.some((v) => v === null)) return;
    const variant = productVariants.find((v) => v.options.every((opt, i) => opt === selected[i]));
    const idInput = document.querySelector('[data-variant-id]');
    const cta = document.querySelector('[data-add-to-cart]');
    const priceEl = document.querySelector('[data-product-price]');
    if (variant && idInput) {
      idInput.value = variant.id;
      if (cta) {
        cta.disabled = !variant.available;
        cta.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (priceEl) {
        let html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<del>' + moneyFormat(variant.compare_at_price) + '</del> ';
        }
        html += moneyFormat(variant.price);
        priceEl.innerHTML = html;
      }
      if (variant.featured_image && variant.featured_image.src) {
        const stage = document.querySelector('[data-gallery-main]');
        const mainImg = stage && stage.querySelector('img');
        if (mainImg) {
          mainImg.src = variant.featured_image.src;
          if (variant.featured_image.alt) mainImg.alt = variant.featured_image.alt;
        }
        const imgId = String(variant.featured_image.id);
        document.querySelectorAll('[data-image-id]').forEach((t) => {
          t.classList.toggle('is-active', t.dataset.imageId === imgId);
        });
      }
    } else if (cta) {
      cta.disabled = true;
      cta.textContent = 'Unavailable';
    }
  };

  document.querySelectorAll('[data-swatches]').forEach((group) => {
    group.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-swatch]');
      if (!btn) return;
      group.querySelectorAll('[data-swatch]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
      btn.setAttribute('aria-pressed', 'true');
      const valueOut = group.querySelector('[data-swatch-value]');
      if (valueOut) valueOut.textContent = btn.dataset.swatch;
      resolveVariant();
    });
  });

  document.querySelectorAll('[data-qty]').forEach((qty) => {
    const input = qty.querySelector('input');
    qty.addEventListener('click', (e) => {
      const step = e.target.closest('[data-qty-step]');
      if (!step || !input) return;
      const dir = parseInt(step.dataset.qtyStep, 10);
      const next = Math.max(1, (parseInt(input.value, 10) || 1) + dir);
      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-hero-slider]').forEach((root) => {
    const slides = root.querySelectorAll('[data-hero-slide]');
    const dots = root.querySelectorAll('[data-hero-dot]');
    const cur = root.querySelector('[data-hero-current]');
    const prev = root.querySelector('[data-hero-prev]');
    const next = root.querySelector('[data-hero-next]');
    if (slides.length < 2) return;
    const INTERVAL = parseInt(root.dataset.interval, 10) || 7000;
    let i = 0, timer = null, paused = false;
    const goTo = (n, manual) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, idx) => {
        s.classList.toggle('is-active', idx === i);
        s.setAttribute('aria-hidden', idx === i ? 'false' : 'true');
      });
      dots.forEach((d, idx) => {
        d.classList.remove('is-active');
        if (idx === i) { void d.offsetWidth; d.classList.add('is-active'); }
      });
      if (cur) cur.textContent = String(i + 1).padStart(2, '0');
      if (manual) restart();
    };
    const tick = () => goTo(i + 1, false);
    const start = () => { if (!paused) timer = setTimeout(tick, INTERVAL); };
    const stop = () => { clearTimeout(timer); timer = null; };
    const restart = () => { stop(); start(); };
    dots.forEach((d, idx) => d.addEventListener('click', () => goTo(idx, true)));
    if (prev) prev.addEventListener('click', () => goTo(i - 1, true));
    if (next) next.addEventListener('click', () => goTo(i + 1, true));
    root.addEventListener('mouseenter', () => { paused = true; stop(); });
    root.addEventListener('mouseleave', () => { paused = false; start(); });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    start();
  });

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const stage = gallery.querySelector('[data-gallery-main]');
    if (!stage) return;
    gallery.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-thumb], [data-video]');
      if (!thumb) return;
      gallery.querySelectorAll('.product__thumb').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (thumb.dataset.video) {
        stage.classList.add('product__media-main--video');
        stage.innerHTML = '<video class="product__video" autoplay muted loop playsinline><source src="' + thumb.dataset.video + '" type="video/mp4"></video><span class="product__media-badge">Live</span>';
      } else if (thumb.dataset.thumb) {
        stage.classList.remove('product__media-main--video');
        const alt = (thumb.dataset.thumbAlt || '').replace(/"/g, '&quot;');
        stage.innerHTML = '<img src="' + thumb.dataset.thumb + '" alt="' + alt + '">';
      }
    });
  });
})();
